import React,{useState, useRef, useContext} from 'react';

import {
    Row,
    Col,            
    Button,    
    FormControl,
    Alert,
    ResponsiveEmbed,
    Spinner
} from 'react-bootstrap';

import axios from 'axios';

import _ from 'lodash';
import UserContext from './../../contexts/UserContext';
import {Uploader, RTEditor} from './../../components';
import Utils from './../../Utils';

const VideoForm = (props) => {
  const {getPkgSize,getAvailableSize,getMaxScormSize} = useContext(UserContext);

  const titleEle = useRef(0);
  const [mode,setMode] = useState(_.get(props,'data.mode','upload'));
  const [errMsg,setErrMsg] = useState('');
  const [size, setSize] = useState(_.get(props,'data.size', 0));
  const videosize_in_mb = _.get(process.env,'REACT_APP_MAX_VIDEO_SIZE',10);
  
  
  const scormsize_in_mb = getMaxScormSize();//_.get(process.env,'REACT_APP_MAX_SCORM_SIZE',50);
  
  const [uploading, setUploading] = useState(false);

  const setDesc = (desc) => {
    setVideo({...video,description : desc});
  }

  const isEdit = () => {
    return _.get(props,'mode',0);
  };
  const defaultVideoStruc = () => {
    var def = {
      mode: mode,
      vid: false,
      link: '',
      title: '',
      description: '',
      duration: 'PT2M0S'
    };

    def = {...def,..._.get(props,'data',{})};

    return def;
  };

  const [video, setVideo] = useState(defaultVideoStruc());

  const onLinkChange = (e) => {
    var url = e.currentTarget.value;    
    fetchVideoDesc(url);
  }

  // const onTitleChange = (e) => {    
  //   setVideo({...video,title: e.currentTarget.value});
  // }


  function getVideoId(url) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);

    return (match && match[2].length === 11)
      ? match[2] 
      : false;
  }

  function fetchVideoDesc(url){  
    const vid = getVideoId(url);
    if(vid){  
      axios.get(`https://www.googleapis.com/youtube/v3/videos?id=${vid}&key=${process.env.REACT_APP_YOUTUBE_API_KEY}&part=snippet,contentDetails&fields=items(snippet/title,snippet/description,contentDetails/duration)`).then(res => {
        setVideo({
          ...video,
          mode: 'youtube',
          link: url, 
          vid: vid, 
          title: _.get(res.data,'items[0].snippet.title',''), 
          description: _.get(res.data,'items[0].snippet.description',''),           
          duration: _.get(res.data,'items[0].contentDetails.duration','PT2M0S')
        });
      }).catch(e=> {/*do nothing*/});
    }
  }

  const showVideo = (vid,pic='') => {
    return <ResponsiveEmbed aspectRatio="21by9" className="mx-1 mx-md-2 px-3">
      <video id="banner_video" controls src={vid} poster={pic}>
          Your browser doesn't support HTML5 video tag.
        </video>
    </ResponsiveEmbed>;
  }

  const getDuration = (dur) => {
    
    var h = 0, m = 0, s = 0;
    if(dur > 3600){
      h = Math.floor(dur/3600);
      dur = dur%3600;      
    }
    if(dur > 60){
      m = Math.floor(dur/60);
      dur = (dur%60);
    }
    if(dur < 60){
      s = Math.round(dur);
    }
    return `PT${h}H${m}M${s}S`;
  }
 
  const onVideoFormSave = () => {
    if(titleEle.current.value ===''){
      window.alert('Please enter title.');
      titleEle.current.focus();
      return false;
    }
    
    props.onFinalize({
       ...video,
       title:titleEle.current.value,
       size: size,
      },'Video',isEdit());
  }

  const onUploadVideo = (name,meta) => { 
    
    if(meta === 'error_file_size'){
      setErrMsg(`You have uploaded ${(name.meta.size/1024/1024).toFixed(1)} MB file, however, 
      the acceptable maximum file size is ${getAvailableSize(videosize_in_mb)} MB. Try again with an acceptable sized file.`);
        
        window.setTimeout(function(){
          setUploading(false);
          setErrMsg('');          
         setVideo(defaultVideoStruc());
        }, 3000);
      
    }else{
          let file_size = (meta.size/1024/1024).toFixed(1);
          setSize(file_size);
          let tot_size = parseInt(file_size) + getPkgSize();
          if(tot_size > scormsize_in_mb){
            setErrMsg(`Total SVASU size allowed is ${scormsize_in_mb} MB,You have used ${getPkgSize()} MB.`);
            window.setTimeout(function(){
              setUploading(false);
              setErrMsg('');
              setVideo(defaultVideoStruc);
            },9000);
            return;
          }else{
            setErrMsg('');
            setVideo({
              mode: 'upload',
              link: Utils.apiUrl('file?f='+name),
              vid: name, 
              title: '', 
              description: '',
              duration: getDuration(meta.duration)
            });            
          }  
        }
    setUploading(false);
   
  }

  const startUploading = (attr, status) =>{
    if(status === 'rejected_file_type'){
      setUploading(false);
      window.alert("Please follow instructions to upload file.");
    }
    else{
      if(errMsg===''){
        setUploading("Please wait... We are processing your file..");      
      }
    }
  }

  return <>
    <div className="videoedit">
    {isEdit()===0 && <div className="mt-2">
      {/* <Button 
        variant={mode==='upload' ? "dark" : "light"} 
        className={`mx-1 ${mode==='upload' ? "active" : ""}`}
        onClick={() => {setMode('upload');setErrMsg('');}}>
          Upload <span className="fa fa-upload" />
      </Button> */}
      {/* <Button 
        variant={mode==='youtube' ? "dark" : "light"} 
        className={`mx-1 ${mode==='youtube' ? "active" : ""}`}
        onClick={() => {setMode('youtube');setErrMsg('');}}>
          Youtube <span className="fa fa-youtube" />
      </Button> */}
    </div>}
    {isEdit()===1 && <h4 className="m-3">Video {mode=== 'upload' ? 'Upload' : mode}</h4>}

    <Row className="m-3">      
      {/* <Col sm={1} className="text-left"><span className={`${mode}-icon text-danger`} /></Col> */}
      <Col sm={12} className="text-left mx-2">
        {(uploading && errMsg==='')&& <><p className="text-center">{uploading}   <Spinner animation="border" variant="dark" /></p> </>}
                {/* {mode==='upload' && video.link==='' && <div style={{height: 150}}> */}
        { video.link==='' && <div title="Select File">
          <Uploader
          instructions={`Click the icon or drag and drop the file to upload your video file. Max file size allowed is ${getAvailableSize(videosize_in_mb)} MB. Supported file formats are .mp4, .ogv, .webm, and .mov  only.`}
          accept="video/*"
          uploadUrl={Utils.apiUrl('saveupload')}
          maxSizeBytes={getAvailableSize(videosize_in_mb)*1024*1024}
          onUpload={onUploadVideo} 
          onSubmit={startUploading} />
          </div>}
          {errMsg !== '' && <>
          <Alert variant="danger" className="p-3"><i className="fa fa-exclamation-circle" />  { errMsg}</Alert>
          </>}
        {mode==='youtube' && <FormControl          
            onChange={onLinkChange}
            defaultValue={video.mode==='youtube' ? video.link : ''}
            placeholder="Paste youtube link here"
            aria-label="Video link"              
        />}        
        {video.vid && errMsg === '' &&  <FormControl className="mt-2" type="input" defaultValue={video.title} ref={titleEle} placeholder="* Enter your title here" />}      
        {video.vid && errMsg === '' && 
          <RTEditor name="field" as="textarea" srcType="video" setDesc={setDesc} className="mt-2" value={video.description} placeholder="* Add your description here" />}
        {mode==='upload' && video.link!=="" && errMsg === '' && showVideo(video.link)}
        {mode==='youtube' && video.vid && errMsg === '' && <iframe title="Youtube" className="my-2" border="0" width="420" height="315" src={`https://www.youtube.com/embed/${video.vid}?controls=0`}></iframe>}
        {video.link!=='' && errMsg === '' && <div className="cta"><hr/><Button onClick={onVideoFormSave} variant="success">Save</Button></div>}
      </Col>
    </Row>
    </div>
  </>
}

export default VideoForm;